import { render, staticRenderFns } from "./junction-box-terminal-block.component.vue?vue&type=template&id=3528859f&scoped=true"
import script from "./junction-box-terminal-block.component.ts?vue&type=script&lang=ts&external"
export * from "./junction-box-terminal-block.component.ts?vue&type=script&lang=ts&external"
import style0 from "./junction-box-terminal-block.component.vue?vue&type=style&index=0&id=3528859f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3528859f",
  null
  
)

export default component.exports